import { RefObject, useEffect } from 'react';
import { useBrowser } from '../../common/services/BrowserService';
import { Dispatch } from '../FormState/formStateReducer';

interface Props {
  dispatch: Dispatch;
  headingRef: RefObject<HTMLHeadingElement>;
  usingKeyboard?: boolean;
}

//This is for users using the keyboard to navigate the booking form
export const useKeyboard = ({ dispatch, headingRef, usingKeyboard }: Props) => {
  const { window, document } = useBrowser();

  useEffect(() => {
    if (usingKeyboard) {
      // Focus on the heading of each section
      if (document?.activeElement?.tagName !== 'INPUT') {
        headingRef?.current?.focus();
      }
    } else {
      const tabKeyPressed = (ev: KeyboardEvent) => {
        if (ev.key === 'Tab') {
          dispatch({ type: 'update-meta', partial: { usingKeyboard: true } });
          window?.removeEventListener('keydown', tabKeyPressed);
        }
      };

      window?.addEventListener('keydown', tabKeyPressed);
    }
  }, [dispatch, document, headingRef, window, usingKeyboard]);
};

export const keyPressWrapper = (key: string, onClick: (() => void) | undefined) => {
  if (key === 'Enter' || key === ' ') {
    onClick && onClick();
  }
};
